<template>
  <div>
    <div class="handle-search">
      <el-button
        type="primary"
        icon="el-icon-circle-plus-outline"
        size="small"
        @click="showAdd()"
      >新增</el-button>
      <div class="search-box">
        <div class="searchItem">
          <el-date-picker
            v-model="query.StartTime"
            style="width:140px"
            type="date"
            size="small"
            value-format="yyyy-MM-dd"
            placeholder="开始日期"
            @change="getData()"
          ></el-date-picker>
          <span>&nbsp;-&nbsp;</span>
          <el-date-picker
            v-model="query.EndTime"
            style="width:140px"
            type="date"
            size="small"
            value-format="yyyy-MM-dd"
            placeholder="结束日期"
            @change="getData()"
          ></el-date-picker>
        </div>
      </div>
    </div>
    <el-table
      :data="tableData"
      border
      class="table"
      ref="multipleTable"
      :height="tableHeight"
      @row-click="showAdd"
      :header-cell-style="{background:'#F3F4F7',color:'#555'}"
    >
      <el-table-column type="index" label="序号" width="50"></el-table-column>
      <el-table-column label="挂号费（$）" prop="configRegistrationFee"></el-table-column>
      <el-table-column prop="configPrice" label="单价（$/KG）"></el-table-column>
      <el-table-column prop="startTime" label="生效时间"></el-table-column>
      <!-- <el-table-column label="操作">
        <template slot-scope="scope">
          <div>
            <el-button type="danger" icon="el-icon-delete">删除</el-button>
          </div>
        </template>
      </el-table-column> -->
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal"
        :page-sizes="[ 20,50,100,200]"
        @size-change="sizeChange"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>

    <el-dialog title="新增/修改物流" :visible.sync="isAddData" width="500px">
      <el-form ref="form" :model="form" label-width="120px" width="40%">
        <el-form-item label="生效时间">
          <el-date-picker
            size="small"
            v-model="form.startTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择生效时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="挂号费">
          <el-input
            v-model="form.configRegistrationFee"
            placeholder="请输入挂号费"
            style="width:220px"
            size="small"
          ></el-input>&nbsp;$
        </el-form-item>
        <el-form-item label="单价">
          <el-input v-model="form.configPrice" placeholder="请输入单价" style="width:220px" size="small"></el-input>&nbsp;$/KG
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isAddData = false">取 消</el-button>
        <el-button type="primary" @click="submitAdd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  AddOrUpdateTransportRuleConfig,
  GetTransportRulesPage
} from "@/utils/api";
export default {
  data() {
    return {
      isAddData: false,
      tableData: [],
      form: {},
      pageTotal: 50,
      tableHeight: 0,
      query: {
        Limit: 20,
        pageStart: 1
      }
    };
  },
  methods: {
    getData() {
      GetTransportRulesPage(this.query).then(res => {
        if (res) {
          this.tableData = res.data;
          this.pageTotal = res.totalData;
        }
      });
    },
    showAdd(item) {
        if (item) {
        this.form = JSON.parse(JSON.stringify(item));
      } else {
        this.form = {
          id: -1
        };
      }

      this.isAddData = true;
    },
     submitAdd() {
      let { configPrice,configRegistrationFee,startTime } = this.form;
      if (!configPrice || !configRegistrationFee || !startTime) {
        this.$message.error("单价、挂号费、生效时间不能为空");
        return;
      }

      AddOrUpdateTransportRuleConfig({
          ...this.form,
          configPrice:Number(configPrice),
          configRegistrationFee:Number(configRegistrationFee)
      }).then(res => {
        if (res) {
          this.$message.success("操作成功");
          this.isAddData = false;
          this.getData();
        }
      });
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageStart", val);
      this.getData();
    },
    sizeChange(val) {
      this.$set(this.query, "Limit", val);
      this.getData();
    }
  },
  created() {
    this.getData();
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight =
        window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 135;
    });
  }
};
</script>

<style lang="less" scoped>
.handle-search {
  background: #f3f3f3;
  border: 1px solid #ddd;
  padding: 10px 15px;
  margin-bottom: 20px;
  border-radius: 5px;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  .search-box {
    display: flex;
    display: -webkit-flex;
    .searchItem {
      margin-right: 20px;
    }
  }
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
/deep/ .el-table__row {
  cursor: pointer;
}
</style>